import React from 'react'
import { Controller } from 'react-hook-form'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'

const Rpps: React.FC = () => {
    const { control, watch } = useFormContextUser()
    const validRpps = watch('validRpps')

    return (
        <Controller
            control={control}
            name="rpps"
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="input"
                    label="Identifiant RPPS"
                    locked
                    status={{
                        error,
                        valid: validRpps,
                    }}
                    placeholder="Identifiant RPPS"
                    dataCyScope="UserField"
                    {...field}
                    value={field?.value ?? ''}
                    disabled
                />
            )}
        />
    )
}

export default Rpps
